import React, { useCallback, useState } from "react";
import LPStats from "./LPStats";
import LPCoursePage from "./LPCoursePage";
import LPJourney from "./LPJourney";
import LPFirstComponent from "./LPFirstComponent";
import ReviewsTab from "../components/ReviewsTab";
import { useMediaQuery, useTheme } from "@mui/material";
import CompanyBasedStats from "../components/CompanyBasedStats";
import CompanyLogos from "../components/CompanyLogos";
import TestimonialsVideo from "../components/TestimonialsVideo";
import LPBlogs from "./LPBlogs";
import FAQs from "../FAQs/FAQs";
import Awards from "./Awards";
import Timer from "../components/Timer";
import Instructors from "../components/Instructors";
import HR from "../components/HR";
import IndustryTrend from "../components/IndustryTrend";
import NewsRoom from "../components/NewsRoom";
import MicrosoftCert from "./MicrosoftCert";
import LPMap from "./LPMap";
import Navbar from "../DevopsV2/components/Navbar";
import StickyFooter from "../DevopsV2/components/StickyFooter";
import Footer from "../DevopsV2/components/Footer";
import ReferAndEarn from "../DevopsV2/components/ReferAndEarn";
import YouTubeVideoCarousel from "../DevopsV2/components/YouTubeVideoCarousel";
import ReviewsSection from "../DevopsV2/components/ReviewsSection";
import GoogleReviews from "../DevopsV2/components/GoogleReviews";
import V2InstructorContent from "../DevopsV2/components/InstructorScrollable/v2InstructorContent";
import MilestoneSection from "../DevopsV2/components/MilestoneSection";
import FAQSection from "../DevopsV2/components/FAQSection";
import WhatsAppCommunity from "../DevopsV2/components/WhatsAppCommunity";
import AwardsRecognition from "../DevopsV2/components/AwardsRecognition";
import CollaborationTIHIITPatna from "../DevopsV2/components/CollaborationTIHIITPatna";
import CollaborationMicrosoft from "../DevopsV2/components/CollaborationMicrosoft";
import StillNotSure from "../DevopsV2/components/StillNotSure";
import CoursePageV2 from "./CoursePageV2";
import BlogsV2 from "./BlogsV2";
import SuccessStoriesV3 from "../DevopsV3/components/SuccessStoriesV3";
import { Helmet } from "react-helmet-async";
import PaperliveLogo from "../DevopsV2/images/paperlive-new-logo.webp";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Paperlive Learning",
  "url": "https://paperlive.in",
  "logo": `https://paperlive.in${PaperliveLogo}`,
  "sameAs": [
    "https://www.instagram.com/paperlive_learning/",
    "https://www.linkedin.com/company/paperlive-learning/",
    "https://www.youtube.com/channel/UCmoB9HjrMnB3eZ64qzb5lBg"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "reviewCount": "1000"
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Paperlive Learning",
  "url": "https://paperlive.in"
};

const courseName = "DevOps Course Online | In Collaboration with Microsoft and AWS";
const courseDescription = "Master DevOps with hands-on training in CI/CD, Docker, Kubernetes, AWS & automation tools. Enroll in the online DevOps course in collaboration with Microsoft and AWS and accelerate your tech career";
const coursePrice = "59999";
const courseImage = "https://paperlive.in/static/media/HeroImageIITPatna.48e3a58e629c15120cda.webp";

/* Reviews shown on-page in ReviewsSection/GoogleReviews — mirrored here so
   structured data matches visible content per Google's review-snippet policy. */
const courseReviews = [
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Nill Singh" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-11-01",
    "reviewBody": "The PaperLive DevOps training helped me move from basic knowledge to mastering tools like Kubernetes, Terraform, and CI/CD pipelines. The instructors are professionals from top companies and make learning easy with real projects."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Dishari" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-09-01",
    "reviewBody": "This course is a complete package for DevOps learners. PaperLive Learning covers everything from CI/CD automation to managing cloud infrastructure. The real-time project submissions and timely assessments helped me stay on track."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Nim Dawa Sherpa" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-09-01",
    "reviewBody": "PaperLive Learning helped me make a successful career shift into cloud engineering. The course is intense but rewarding, filled with practicals, quizzes, and resume-building sessions. Every doubt was answered patiently, and I now feel job-ready with my DevOps skills."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Arko Mitra" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-04-01",
    "reviewBody": "I joined Paperlive Learning to strengthen my DevOps skills, and the hands-on training really made a difference. The mock interviews and real-time projects helped me gain confidence and clarity."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Iswarya T" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-04-01",
    "reviewBody": "I gained valuable knowledge through this platform. The learning environment is very supportive, and the guidance provided helped me a lot throughout my journey. Because of Paperlive, I was able to secure a placement, which I'm truly grateful for."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Ashish kumar jha" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-01-01",
    "reviewBody": "I recently completed the DevOps program with placement support from Paperlive Learning and overall it was a really positive experience for me. The way the course was structured made it easy to follow, everything was explained step by step, and the trainers were patient and knowledgeable."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Mabiya Parween" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-10-01",
    "reviewBody": "DevOps became easy with PaperLive Learning's structured approach. The mentors simplified every tool with practical examples. I now have the confidence to handle real projects effectively."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Sajid Shahjad" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-07-01",
    "reviewBody": "One of the best platforms to learn DevOps and cloud. The hands-on labs made a big difference. While enrolling, I got the best deal in comparison to other platforms."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Ayush Kumar" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-01-01",
    "reviewBody": "I recently completed the Cloud and DevOps training program from Paperlive Learning and it was a great learning experience. The course was very well structured and covered all major DevOps tools and cloud concepts like Docker, Kubernetes, Jenkins, Terraform, and AWS."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Yuvanandhan R" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2026-04-01",
    "reviewBody": "I started my journey in Paperlive as a fresher. Many said it's impossible for a fresher to learn and get placed in the field of DevOps. But with the consistent training and mentorship from Paperlive Learning I really cracked my interview and got placed within the given period of time."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Rekha Deogharia" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-12-01",
    "reviewBody": "I found PaperLive Learning while looking for affordable DevOps training. Trainers knew their stuff, the sessions were interactive, and the placement team was with me until I got interview calls."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Anjum Firadaush" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-11-01",
    "reviewBody": "What makes PaperLive Learning stand out is their dedication to job-focused education. We didn't just learn AWS or Azure, we actually built real-time apps and pipelines. I loved the mix of DevOps with GenAI, it gave me an edge."
  },
  {
    "@type": "Review",
    "author": { "@type": "Person", "name": "Tanweer Alam" },
    "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
    "datePublished": "2025-10-01",
    "reviewBody": "PaperLive Learning is an excellent online platform for anyone looking to upgrade their tech skills through practical, hands-on training, especially in high-demand fields like DevOps, Cloud Computing, and Web Development."
  }
];

const aggregateRating = {
  "@type": "AggregateRating",
  "ratingValue": "4.9",
  "bestRating": "5",
  "reviewCount": "1000"
};

const courseSchema = {
  "@context": "https://schema.org",
  "@type": "Course",
  "name": courseName,
  "description": courseDescription,
  "provider": {
    "@type": "Organization",
    "name": "Paperlive Learning",
    "sameAs": "https://paperlive.in"
  },
  "courseMode": "Online",
  "inLanguage": "en",
  "educationalCredentialAwarded": "Microsoft and AWS Certification",
  "aggregateRating": aggregateRating,
  "review": courseReviews
};

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": courseName,
  "description": courseDescription,
  "image": courseImage,
  "brand": {
    "@type": "Brand",
    "name": "Paperlive Learning"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://paperlive.in/",
    "priceCurrency": "INR",
    "price": coursePrice,
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": aggregateRating,
  "review": courseReviews
};


const executiveFaqs = [
  {
    question: "What is the PaperLive DevOps and Multi-Cloud Certification?",
    answer:
      "This is a six-month online program that is both demanding and interesting. It is specifically created for both freshers and working professionals who wish to accelerate their entry into cloud and DevOps jobs, build a professional network, and gain practical knowledge and skills. Microsoft is the one who grants the certification.",
  },
  {
    question: "What are the mock interview eligibility criteria for placements?",
    answer:
      "To be eligible for placements, candidates must achieve a minimum average score of 40% across all three mock interviews.If a candidate is unable to secure a 40% average, they will be moved to the Performance Improvement Program (PIP) for additional guidance, practice, and support.Once the candidate successfully achieves a 40% average, they will be transitioned back to the placement process."
  },
  {
    question: "What can I anticipate from the for DevOps and Cloud job ready program?",
    answer:
      "Anticipate to complete multiple industry-relevant exercises that are modelled after real-world work environments, enabling you to become a cloud/DevOps expert on par with top industry standards. Through this curriculum, students will develop their technical soundness and learn how to think beyond the box.",
  },
  {
    question: "What kind of educational experience can I anticipate?",
    answer:
      "This curriculum will combine recorded content on several subjects with live lectures delivered in a boot camp style. A combination of interactive lectures from well-known academics and business executives will make up the curriculum. At least one cloud domain certification is held by each of our industry specialists, and many of them possess several domain certifications. During this course, you can anticipate a lively setting where you will enhance your expertise in the field and grow your professional network.",
  },
  {
    question: "What amount of hours a week is needed of me?",
    answer:
      "The program schedule is structured to make sure you can work a job and successfully complete your studies. It should be sufficient to dedicate 10–12 hours per week to the program. That being said, the more time you invest, the more you will learn from the curriculum.",
  },
];


const defaultFaqs = [
  {
    question: "What is the fee for PaperLive's DevOps course online, and are EMI options available?",
    answer: "The course fee is competitively priced for the Indian market, and no-cost EMI options are available through major banks and NBFCs — making the DevOps training online accessible without upfront financial pressure."
  },
  {
    question: "Are there any scholarships or early-bird discounts on this DevOps certification program?",
    answer: "Yes, PaperLive periodically offers early-bird pricing and merit-based scholarships on the DevOps certification program. Reach out to the admissions team to check current offers before enrolling."
  },
  {
    question: "What is the refund policy for this DevOps training online?",
    answer: "PaperLive offers a structured refund policy — if you're unsatisfied within the initial sessions of the DevOps training online, you can claim a refund as per the terms shared at enrollment."
  },
  {
    question: "Is there a free demo class available before I pay for the DevOps course?",
    answer: "Yes, PaperLive offers a free demo session for the DevOps course so you can evaluate the teaching quality, curriculum depth, and instructor before committing."
  },
  {
    question: "Does this DevOps training online cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "Yes — building and managing CI/CD pipelines using Jenkins, GitHub Actions, and GitLab CI is a core module in the DevOps training online, with hands-on project work included."
  },
  {
    question: "Is Docker and Kubernetes part of this DevOps course online?",
    answer: "Docker containerization and Kubernetes orchestration are both covered in depth in this DevOps course online, including real-world cluster deployments and production-grade configurations."
  },
  {
    question: "Does the DevOps certification curriculum include Infrastructure as Code (Terraform, Ansible)?",
    answer: "Yes. Terraform for cloud provisioning and Ansible for configuration management are dedicated modules in the DevOps certification curriculum — both are heavily sought after by employers."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this DevOps training?",
    answer: "The DevOps training includes a full observability module covering Prometheus, Grafana dashboards, and the ELK stack — skills that directly come up in senior DevOps interviews."
  },
  {
    question: "What scripting languages are taught in this DevOps course online?",
    answer: "Shell scripting, Python for automation, and YAML configuration are all covered in the DevOps course online — the scripting foundation every DevOps engineer needs on the job."
  },
  {
    question: "Is Git and version control covered as part of this DevOps training online?",
    answer: "Yes — Git workflows, branching strategies, and code review practices form the foundation of the DevOps training online before advancing into CI/CD and cloud modules."
  },
  {
    question: "Are the DevOps course online classes held on weekdays, weekends, or both?",
    answer: "PaperLive offers both weekday evening and weekend batches for the DevOps course online — specifically designed so working professionals don't have to choose between job and upskilling."
  },
  {
    question: "How many hours per week does this DevOps training online require?",
    answer: "Expect to invest 8–12 hours per week in the DevOps training online, including live sessions, lab practice, and assignments — manageable alongside a full-time role."
  },
  {
    question: "What happens if I miss a live session of this DevOps certification program?",
    answer: "All live sessions are recorded and made available within 24 hours, so missing a class in the DevOps certification program won't set you back — you can catch up at your own pace."
  },
  {
    question: "Can I access the DevOps course online content on mobile?",
    answer: "Yes, all recorded sessions and course material for the DevOps course online are accessible via mobile browser, so you can learn during your commute or between meetings."
  },
  {
    question: "What system configuration do I need to take this DevOps training online?",
    answer: "A laptop with 8GB RAM and a stable internet connection is sufficient. All lab environments in the DevOps training online are cloud-hosted — no expensive local infrastructure needed."
  },
  {
    question: "Will I get access to live cloud lab environments during this DevOps course?",
    answer: "Yes — the DevOps course provides access to live cloud lab environments on AWS, Azure, and GCP, so you practice on real infrastructure, not simulations."
  },
  {
    question: "What DevOps job roles can I target after completing this DevOps certification?",
    answer: "This DevOps certification prepares you for roles like DevOps Engineer, Site Reliability Engineer (SRE), Cloud Infrastructure Engineer, Platform Engineer, and Release Manager."
  },
  {
    question: "What is the average salary for a DevOps-certified professional in India?",
    answer: "DevOps-certified professionals in India typically earn ₹7–20 LPA depending on experience level, with IIT-backed credentials like this DevOps certification helping in salary negotiations."
  },
  {
    question: "Does PaperLive offer resume building and interview prep as part of the DevOps training?",
    answer: "Yes — the DevOps training includes resume writing support, LinkedIn profile optimization, and mock interview sessions tailored specifically for DevOps hiring rounds."
  },
  {
    question: "Does PaperLive have company tie-ups for DevOps hiring after the course?",
    answer: "PaperLive has active hiring partnerships with companies specifically recruiting DevOps-certified professionals, giving graduates access to exclusive referral opportunities post-course."
  },
  {
    question: "How does this DevOps course online compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications are platform-specific, while this DevOps course online covers the full DevOps lifecycle across multi-cloud environments — making you more versatile and interview-ready across a wider range of employers."
  },
  {
    question: "Is this DevOps training online better than a full-time bootcamp for someone already employed in IT?",
    answer: "Unlike bootcamps that require a career break, this DevOps training online is designed around working professionals — with flexible schedules, recorded backups, and a paced curriculum that doesn't demand full-time availability."
  },
  {
    question: "Why should I choose PaperLive's DevOps certification over a Udemy or Coursera course?",
    answer: "Self-paced platforms give you videos — PaperLive's DevOps certification gives you live instruction, real cloud labs, mentor access, and placement support. It's a program, not just content."
  },
  {
    question: "Is there a peer community or study group for this DevOps course online batch?",
    answer: "Every DevOps course online batch gets a dedicated peer community group for doubt-sharing, project collaboration, and networking with batchmates across India."
  },
  {
    question: "How many doubt-clearing sessions are included in this DevOps training online?",
    answer: "The DevOps training online includes weekly live doubt-clearing sessions with instructors, plus async support via the community channel — so no question goes unanswered."
  },
  {
    question: "Who are the instructors for this DevOps training — academics or industry professionals?",
    answer: "All instructors in this DevOps training are active industry practitioners with hands-on experience at product companies and global IT firms — not just academics or theorists."
  },
  {
    question: "Will this DevOps certification help me get a job abroad or only in India?",
    answer: "The DevOps certification curriculum is globally aligned — covering tools and cloud platforms used worldwide. Many PaperLive graduates have leveraged it for opportunities in the Middle East, UK, and Southeast Asia."
  },
  {
    question: "How is this DevOps certification different from a general IT certificate?",
    answer: "Unlike generic IT certificates, this DevOps certification is domain-specific, backed by Microsoft and AWS, and tied to hands-on project completion — making it far more credible in a DevOps job interview."
  },
  {
    question: "Does completing this DevOps course online make me eligible for any government or PSU tech roles?",
    answer: "The credential attached to this DevOps course online adds institutional legitimacy that is recognized in government tech hiring contexts, particularly for roles in digital transformation and cloud infrastructure projects."
  }
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": defaultFaqs.map((faq) => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
};

export default function LandingPage(props) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [value, setValue] = useState(-1)

  const scrollToSection = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(courseSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <Navbar isSmallScreen={isSmallScreen} scrollToSection={scrollToSection}/>
      <StickyFooter isSmallScreen={isSmallScreen} />
      {/* <Timer isSmallScreen={isSmallScreen} setValue={setValue} /> */}
      <LPFirstComponent isSmallScreen={isSmallScreen}/>
      <CoursePageV2 isSmallScreen={isSmallScreen}/>
      {/* <CompanyBasedStats isSmallScreen={isSmallScreen} /> */}
      {/* <LPMap /> */}
      <div id="companylogos"><CompanyLogos isSmallScreen={isSmallScreen} websitePage="DevopsV2" /></div>
      <LPStats />
      <div id="youtube"><SuccessStoriesV3 isSmallScreen={isSmallScreen} setValue={setValue}/></div>
      <ReviewsSection isSmallScreen={isSmallScreen} setValue={setValue} />
      <GoogleReviews isSmallScreen={isSmallScreen} />
      {/* <HR isSmallScreen={isSmallScreen} setValue={setValue} /> */}
      <V2InstructorContent isSmallScreen={isSmallScreen} setValue={setValue} />
      <BlogsV2 isSmallScreen={isSmallScreen}/>
      <MilestoneSection isSmallScreen={isSmallScreen}/>
      <div id="refer"><ReferAndEarn isSmallScreen={isSmallScreen} /></div>
      <WhatsAppCommunity isSmallScreen={isSmallScreen} />
      <AwardsRecognition isSmallScreen={isSmallScreen} />
      {/* <CollaborationTIHIITPatna isSmallScreen={isSmallScreen}/> */}
      <CollaborationMicrosoft isSmallScreen={isSmallScreen} />
      {/* <NewsRoom isSmallScreen={isSmallScreen} /> */}
      {/* <LPContact /> */}
      <StillNotSure isSmallScreen={isSmallScreen}/>
      <FAQSection isSmallScreen={isSmallScreen} defaultFaqs={defaultFaqs} executiveFaqs={executiveFaqs}/>
      <Footer scrollToSection={scrollToSection}/>
    </React.Fragment>
  );
}